import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';
import { TaskStatus } from '@prisma/client';

type ShareHoldingInstructionsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  taskStatus: TaskStatus;
};

const NumberComponent = ({ number }: { number: number }) => {
  return (
    <div className="flex shrink-0 items-center justify-center w-8 h-8 rounded-md bg-bg-tertiary text-sm">
      <span className="text-fg-primary-900">{number}</span>
    </div>
  );
};

export const ShareHoldingInstructionsModal = ({
  isOpen,
  onClose,
  onSubmit,
  taskStatus,
}: ShareHoldingInstructionsModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex flex-col max-h-[85vh]">
        <DialogHeader className="border-none">
          <DialogTitle>Instructions for share purchase agreement</DialogTitle>
        </DialogHeader>

        <div className="px-6 grow overflow-y-auto">
          <div className="flex flex-col gap-4 h-full">
            <Alert
              variant="info"
              icon={<Icons.InfoCircle className="text-utility-blue-500 mr-3" />}
              title="For Indian residents:"
              description={
                <span className="txt-small-regular text-text-tertiary">
                  Please await the completion of your US corporation formation
                  before proceeding with this step. Your assigned Commenda agent
                  will notify you once you are able to move forward.
                </span>
              }
            />
            <p className="txt-medium-regular text-text-primary">
              For non-Indian directors:
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <NumberComponent number={1} />
                <p className="txt-medium-regular text-text-tertiary">
                  Your Commenda agent will provide you with the exact share
                  subscription amount.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <NumberComponent number={2} />
                <p className="txt-medium-regular text-text-tertiary">
                  Send the subscription amount from your personal account to the
                  entity’s bank account. Ensure that your name is clearly
                  reflected on the account. Please refrain from using joint
                  accounts for this transaction.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <NumberComponent number={3} />
                <p className="txt-medium-regular text-text-tertiary">
                  Upload the bank statement with the share subscription amounts
                  in the next step. Please ensure name of the concerned
                  party(ies) and the date are clearly visible in the statement.
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter className="border-none">
          {taskStatus !== TaskStatus.COMPLETED && (
            <div className="flex justify-end gap-2 items-center">
              <Button variant="secondary" type="button" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={onSubmit}>Ok, I understand</Button>
            </div>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
